import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { SidebarIcon } from './SidebarIcon';
import { canViewSistemaMenu, hasModule } from '../services/permission/permissionService';
import { adminSidebarSections, studentSidebarSections } from '../config/sidebarNavConfig';
import { isSidebarItemActive, sectionHasActivePath as sectionHasActiveSidebarPath } from '../config/sidebarActiveRoutes';

function isItemVisible(item, section) {
  if (item.href === '/cambiar-contrasena' && section.id !== 'usuario') {
    return false;
  }
  if (!item.module) {
    return true;
  }
  return hasModule(item.module);
}

function getVisibleItems(section) {
  return section.items.filter((item) => isItemVisible(item, section));
}

function isSectionVisible(section) {
  if (section.id === 'sistema' && !canViewSistemaMenu()) {
    return false;
  }
  return getVisibleItems(section).length > 0;
}

function buildExpandedState(sections, pathname, openSectionId, getItems = getVisibleItems) {
  const expanded = {};
  sections.forEach((section) => {
    expanded[section.id] = false;
  });

  if (openSectionId) {
    expanded[openSectionId] = true;
    return expanded;
  }

  const activeSection = sections.find((section) => sectionHasActiveSidebarPath(section, pathname, getItems(section)));
  if (activeSection) {
    expanded[activeSection.id] = true;
  }

  return expanded;
}

function itemKey(item) {
  return item.href || item.action;
}

class SidebarNavInner extends Component {
  constructor(props) {
    super(props);
    const sections = props.variant === 'admin' ? adminSidebarSections : studentSidebarSections;
    this.state = {
      expanded: buildExpandedState(sections, props.location.pathname),
    };
  }

  toggleSection = (sectionId) => {
    const sections = this.props.variant === 'admin' ? adminSidebarSections : studentSidebarSections;
    this.setState((prev) => {
      if (prev.expanded[sectionId]) {
        const expanded = {};
        sections.forEach((section) => {
          expanded[section.id] = false;
        });
        return { expanded };
      }

      const expanded = {};
      sections.forEach((section) => {
        expanded[section.id] = section.id === sectionId;
      });
      return { expanded };
    });
  };

  renderItem(item, pathname, showActiveState) {
    const isActive = showActiveState && isSidebarItemActive(item, pathname);
    return (
      <a
        href={item.href}
        className={'sidebar-nav__link' + (isActive ? ' sidebar-nav__link--active' : '')}
        aria-current={isActive ? 'page' : undefined}
      >
        <span
          className={'sidebar-nav__radio' + (isActive ? ' sidebar-nav__radio--selected' : '')}
          aria-hidden="true"
        />
        <span className="sidebar-nav__link-label">{item.label}</span>
      </a>
    );
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.pathname === this.props.location.pathname) {
      return;
    }

    const sections = this.props.variant === 'admin' ? adminSidebarSections : studentSidebarSections;
    this.setState({
      expanded: buildExpandedState(sections, this.props.location.pathname),
    });
  }

  render() {
    const { location } = this.props;
    const sections = this.props.variant === 'admin' ? adminSidebarSections : studentSidebarSections;
    const pathname = location.pathname;

    return (
      <nav className="sidebar-nav" aria-label="Menú principal">
        {sections.filter(isSectionVisible).map((section) => {
          const items = getVisibleItems(section);
          const isExpanded = Boolean(this.state.expanded[section.id]);
          const isActiveSection = sectionHasActiveSidebarPath(section, pathname, items);

          return (
            <div key={section.id} className="sidebar-nav__section">
              <div
                className={
                  'sidebar-nav__section-group' +
                  (isExpanded ? ' sidebar-nav__section-group--open' : '')
                }
              >
                <button
                  type="button"
                  className={
                    'sidebar-nav__section-toggle' +
                    (isExpanded && isActiveSection ? ' sidebar-nav__section-toggle--active' : '')
                  }
                  onClick={() => this.toggleSection(section.id)}
                  aria-expanded={isExpanded}
                >
                  <SidebarIcon name={section.icon} />
                  <span className="sidebar-nav__section-label">{section.title}</span>
                  <span className="sidebar-nav__chevron" aria-hidden="true">
                    {isExpanded ? '▾' : '▸'}
                  </span>
                </button>
                {isExpanded ? (
                  <ul className="sidebar-nav__items">
                    {items.map((item) => (
                      <li key={itemKey(item)}>
                        {this.renderItem(item, pathname, isExpanded)}
                      </li>
                    ))}
                  </ul>
                ) : null}
              </div>
            </div>
          );
        })}
      </nav>
    );
  }
}

export const SidebarNav = withRouter(SidebarNavInner);
